import { useState, useEffect } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import ClassTimeTableCard from './ClassTimeTableCard';
import { TabView, TabPanel } from 'primereact/tabview';
import TeacherTimeTableCard from './TeacherTimeTableCard';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const TimeTableConfiguration = () => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [teachersList, setTeachersList] = useState([]);
    const [classConfigurationData, setClassConfigurationData] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [academicYearList, setAcademicYearList] = useState([]);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData?._id);
        GetTeachersList(loginData?._id);
    }, []);

    const getFinancialYearData = async (id) => {
        const years = await CommonConfig.getFinancialYears(id);
        setAcademicYearList(years);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetClassList(id, selectedAcYear ?? currentYear?.value);
        await GetClassConfigurationDetail(id, selectedAcYear ?? currentYear?.value);
    }

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            Loader.show();
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var formatedData = res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        ...x,
                        Class: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`,
                        value: x?._id
                    }));
                    setClassList(formatedData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTeachersList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getTeacherDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTeachersList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassConfigurationDetail = async (id, financialYearId) => {
        try {
            let data = {
                UserId: id,
                FinancialYearId: financialYearId,
            }
            Loader.show();
            await api.post(APIConstant.path.getClassConfigurationList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let resData = res.data;
                    setClassConfigurationData(resData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    return (
        <div className='wayment-owner-dashboard et-master-page' style={{ height: 'auto'}}>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-clock"></i>
                    <h2>Time Table</h2>
                </div>
            </div>
            <div className='e-tab-main'>
                {selectedYear && (
                    <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)} >

                        <TabPanel header="Class">
                            <div style={{ maxHeight: 'calc(100vh - 140px)', overflowY: 'auto' }}>
                                {
                                    classList?.map(x => (
                                        <ClassTimeTableCard key={x?._id} ClassId={x?._id} ClassName={x?.Class} ClassConfigurationData={classConfigurationData} financialYearId={selectedYear} academicYearList={academicYearList} />
                                    ))
                                }
                            </div>
                        </TabPanel>
                        <TabPanel header="Teacher">
                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                {
                                    teachersList.map(x => (
                                        <TeacherTimeTableCard key={x?._id} TeacherId={x?._id} TeacherName={x?.Name} ClassList={classList} financialYearId={selectedYear} academicYearList={academicYearList} />
                                    ))
                                }
                            </div>
                        </TabPanel>
                    </TabView>
                )}
            </div>
        </div>
    );
};

export default TimeTableConfiguration;
